import React from 'react';
import {Provider as RollbarProvider, ErrorBoundary} from '@rollbar/react';
import {Provider as ReduxProvider} from 'react-redux';
import {ErrorComponent} from '@stjudecloud/ui-react';
import {RelayEnvironmentProvider} from 'react-relay';
import {
  PaginationModule,
  ColumnAutoSizeModule,
  RowSelectionModule,
  ColumnApiModule,
  QuickFilterModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
} from 'ag-grid-community';
import {AgGridProvider} from 'ag-grid-react';

import graphqlEnvironment from './graphqlEnvironment';

import configureStore from './store/configureStore';
import App from './components/App';
import DatabrowserFiltersProvider from './components/atoms/DatabrowserFiltersProvider';

import './theme/theme.scss';
import initializeDatadog from './datadog';

const env = process.env.NODE_ENV;

const rollbarConfig = {
  enabled: env === 'production' || env === 'staging',
  accessToken: document.querySelector("meta[name='rollbar-access-token']").content,
  environment: env,
  captureIp: 'anonymize',
};

if (env === 'production' || env === 'staging') {
  initializeDatadog();
}

const modules = [
  PaginationModule,
  QuickFilterModule,
  ColumnAutoSizeModule,
  RowSelectionModule,
  ColumnApiModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
];

const store = configureStore();
const fallbackUI = () => <ErrorComponent variant="internalServerError" />;

const ReactApp = () => (
  <RollbarProvider config={rollbarConfig}>
    <ErrorBoundary fallbackUI={fallbackUI}>
      <RelayEnvironmentProvider environment={graphqlEnvironment}>
        <ReduxProvider store={store}>
          <DatabrowserFiltersProvider>
            <AgGridProvider modules={modules}>
              <App />
            </AgGridProvider>
          </DatabrowserFiltersProvider>
        </ReduxProvider>
      </RelayEnvironmentProvider>
    </ErrorBoundary>
  </RollbarProvider>
);

export default ReactApp;
